import { z } from 'zod'

/**
 * Where a signer is in their session. The answerer (Q&A) session uses a
 * subset: an answerer does not wait on a routing order and has nothing to
 * sign.
 */
export const SIGNING_SESSION_GATES = ['consent', 'waiting', 'ready', 'signed', 'unavailable'] as const

export const signingSessionGateSchema = z.enum(SIGNING_SESSION_GATES)

export type SigningSessionGate = z.infer<typeof signingSessionGateSchema>

export const QA_SESSION_GATES = ['consent', 'ready', 'unavailable'] as const satisfies readonly SigningSessionGate[]

export type QaSessionGate = (typeof QA_SESSION_GATES)[number]
